import React, {useEffect} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import WithUpdateLookCartItem from "../../../hocs/withUpdateLookCartItem";
import {CABINET_GROUP} from "../../../../kvComponent/core/constants";
import CabinetSwitchers from "../../../../kvComponent/navigation/cabinetSwitchers";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {setCabinetsApplyTo} from "../../../../../actions/navigationFunctions";
import {updateCanvasCount} from "../../../../../actions/actionFunctions";
import {getCurrentLayout} from "../../../../appLayout";
import {navFeatureCLick} from "../../lookFunctions";


const LookWizardContentMatch = (props) => {

  const {featureGroup, cabinetsApplyTo, setCabinetsApplyTo, wizardSelectedValues, wizardActiveStep, updateCanvasCount} = props;

  useEffect(() => {
    const layout = getCurrentLayout();
    CABINET_GROUP.forEach(partId => {
      const featureGroup = layout.getFeatureGroupByPartId(partId);
      if (featureGroup) {
        featureGroup.activeFeatureBeforeAllWalls = featureGroup.activeFeature;
      }
    })
  }, [])

  if (!featureGroup || !CABINET_GROUP.includes(featureGroup.partId)) {
    return null
  }

  const checkboxClick = async (updateLookCartItem) => {
    const featureSelected = wizardSelectedValues && wizardSelectedValues[wizardActiveStep]
      ? wizardSelectedValues[wizardActiveStep].selectedFeature
      : null
    // console.log("featureSelected", featureSelected);

    setCabinetsApplyTo(cabinetsApplyTo.length ? [] : CABINET_GROUP);

    if (!featureSelected) {
      return null
    }

    const featureLabel = Analytics.getSkuForAnalytics(featureSelected);
    const analyticsLabel = LOOK_JOURNEY_ANALYTIC_EVENTS.lookWizardListFeature + featureLabel;
    Analytics.sendClickEvent(analyticsLabel);

    if (!cabinetsApplyTo.length) {
      await CabinetSwitchers.applyClickTo(featureSelected, true, CABINET_GROUP)
    } else {
      const layout = getCurrentLayout();
      CABINET_GROUP.forEach(partId => {
        if (partId === featureSelected.partId) {
          return
        }
        const featureGroup = layout.getFeatureGroupByPartId(partId);
        if (featureGroup && featureGroup.activeFeatureBeforeAllWalls) {
          navFeatureCLick(featureGroup.activeFeatureBeforeAllWalls, "all_walls");
        }
      })
    }

    // const featuresToClick = groheSameColorCheckboxApplied ? currentColorFeatures : sameColorFeatures;
    updateLookCartItem(featureSelected, true);
    updateCanvasCount()
  }

  return (
    <div className="lw-content__other-checkbox">
      <span className="lk-feature__options-title">
        <FormattedMessage id="grohe.sameColor.checkbox.cabinets"/>
      </span>
      <WithUpdateLookCartItem>
        {(updateLookCartItem) => (
          <FormControlLabel
            control={
              <Switch
                // disabled={!featureSelected}
                className="gm-ios-checkbox"
                disableRipple
                checked={!!cabinetsApplyTo.length}
                onChange={() => checkboxClick(updateLookCartItem)}
                color="primary"
              />
            }
          />
        )}
      </WithUpdateLookCartItem>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardSelectedValues, wizardActiveStep} = store.wizardState;
  const {cabinetsApplyTo} = store.navigationState;

  return {
    wizardSelectedValues,
    wizardActiveStep,
    cabinetsApplyTo
  };
};

const mapDispatchToProps = {
  setCabinetsApplyTo,
  updateCanvasCount,
}

export default connect(mapStateToProps, mapDispatchToProps)(LookWizardContentMatch)
